import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=6e225a1e&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
import style0 from "./Project.vue?vue&type=style&index=0&id=6e225a1e&prod&lang=css"
import style1 from "./Project.vue?vue&type=style&index=1&id=6e225a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e225a1e",
  null
  
)

export default component.exports